import axios from "axios";
import { ImportWorkingStatus } from "../../types";

interface IUpdateImportWorkingStatus {
    id: string,
    workingStatus: ImportWorkingStatus
}

export const updateImportWorkingStatus = async (param: IUpdateImportWorkingStatus): Promise<void> => {
    const response = await axios.post(`/booking/import/setImportLineWorkingStatus`, null, {
        params: {workingStatus: param.workingStatus, id: param.id}
    });
    return response.data;
};

export default updateImportWorkingStatus;
